import {LoadedModel} from "../entities/loaded_model";
import {GLBModelLoader} from "./loaders/glb";
import {FBXModelLoader} from "./loaders/fbx";
import {OBJLModelLoader} from "./loaders/obj";
import {ImageModelLoader} from "./loaders/image";
import {GifModelLoader} from "./loaders/gif";
import * as THREE from "three";


//Accept URI
// Load Animated Model
// Return model & animationsMap
// Assign to model
// Adjust getters/setters for model

export class ModelManager {
	models = {}

	loadingManager

	loaders = {
		glb: null,
		fbx: null,
		obj: null,
		image: null,
	}

	//Local load variables
	useLocalLoad = false
	localBase = "http://localhost:8869"
	remoteUrls = [
		"https://shdw-drive.genesysgo.net",
		"https://app.alphabatem.com",
		"https://media.alphabatem.com"
	];


	modelAnimationBindings = {};

	onLoad = function () {
	}

	loadingCount = 0;
	loadedCount = 0;


	constructor(onLoad) {
		this.onLoad = onLoad

		this.setupLoadingManager();
		this.loaders = {
			glb: new GLBModelLoader(this.loadingManager),
			fbx: new FBXModelLoader(this.loadingManager),
			obj: new OBJLModelLoader(this.loadingManager),
			image: new ImageModelLoader(this.loadingManager),
			gif: new GifModelLoader(this.loadingManager),
		}

		this.loadReadyPlayerMeBase()
	}

	setLocalLoad(loadLocal) {
		this.useLocalLoad = loadLocal
	}

	setupLoadingManager() {
		this.loadingManager = new THREE.LoadingManager()
		this.loadingManager.onLoad = () => {
			console.log("LoadingManager::Load Complete")
		}
		this.loadingManager.onProgress = (xhr) => {
			console.log("LoadingManager::Progress Complete", xhr)
		}
	}


	loadReadyPlayerMeBase() {
		this.addModel("_animation_skeleton_v2", "https://shdw-drive.genesysgo.net/J6TziKmieMZK1dmtsLPzo1BFoMxDdubBmXKkudhKmHXM/Rig_inPlace.glb", () => {
			const m = this.getLoadedModel("_animation_skeleton_v2")

			for (let i = 0; i < m.animations.length; i++) {
				const tracks = []

				for (let a = 0; a < m.animations[i].tracks.length; a++) {
					//TODO Fix so animations work!!!
					// if (m.animations[i].tracks[a].name.indexOf("Hips") > -1 || m.animations[i].tracks[a].name.indexOf("mixamorig") === -1) {
					if (m.animations[i].tracks[a].name.indexOf("mixamorig") === -1) {
						// console.log("Skipping: ", m.animations[i].tracks[a].name)
						// m.animations[i].tracks[a].name = "Armature.position"
						continue
					}

					m.animations[i].tracks[a].name = m.animations[i].tracks[a].name.replace("mixamorig", "")
					// console.log(m.animations[i].tracks[a].name)
					tracks.push(m.animations[i].tracks[a])
				}

				m.animations[i].tracks = tracks
			}

			// console.log(`"_animation_skeleton_v2" model loaded`, m)
			this.loaders.glb.setDefaultAnimations(m.animations)
		})
	}

	setModelAnimationBindings(modelKey, animationsMap) {
		this.modelAnimationBindings[modelKey] = animationsMap;
	}

	getModelAnimationBindings(modelKey) {
		if (this.modelAnimationBindings[modelKey])
			return this.modelAnimationBindings[modelKey]

		return {
			"idle": "Idle",
			"walk": "Walking",
			"jump": "Jump",
			"run": "Run",
		}
	}

	addModel(key, modelUri, callback) {
		if (this.hasModel(key)) {
			callback(this.models[key.toLowerCase()])
			return
		}

		if (modelUri === "") {
			console.warn("Model URI is empty for key:", key)
			return
		}
		// console.log("Adding Model: " + key)
		// this.loadModel(modelUri, (m) => this.onModelLoaded(key, m, callback)) - Always load with animations from now to comply with model

		try {
			this.loadAnimatedModel(modelUri, (m, data) => {
				if (!m) {
					console.warn("Unable to load model: ", key, data)
					this.loadingCount--

					if (this.allLoaded())
						this.onLoad()

					return
				}


				m.castShadow = true
				m.receiveShadow = true
				// m.traverse((child) => {
				// 	if (child.isMesh) {
				// 		child.castShadow = true
				// 		child.receiveShadow = true
				// 	}
				// })

				const model = new LoadedModel(key, m, data)
				model.uri = modelUri

				// console.log("model loaded: ", model)
				this.onAnimatedModelLoaded(model, callback)
			})
		} catch (e) {
			console.error("Error loading model: ", e)
			this.loadedCount++; //Mark as loaded (nothing we can do just yet if its erroring)
			console.debug("Loaded Count(ERR): ", this.loadedCount)
			//Dont call the callback
		}
	}

	onAnimatedModelLoaded(model, callback = null) {

		// console.log("ModelManager: loaded animated model " + model.getKey(), model)
		this.setModel(model)
		this.loadedCount++;
		// console.log("Loaded Count: ", this.loadedCount)
		if (callback !== null)
			callback(model.getModel())

		if (this.allLoaded())
			this.onLoad()
	}

	allLoaded() {
		return this.loadingCount === this.loadedCount
	}

	isLoading() {
		return this.loadingCount > 0;
	}

	setModel(model) {
		this.models[model.getKey()] = model
	}

	getLoadedModel(key) {
		return this.models[key.toLowerCase()]
	}

	getModel(key) {
		if (!key) return
		
		return this.models[key.toLowerCase()].getModel()
	}

	hasModel(key) {
		return this.models[key.toLowerCase()] !== undefined
	}

	/**
	 * @deprecated Use addModel instead
	 * @param url
	 * @param callback
	 */
	loadModel(url, callback) {
		this.loadAnimatedModel(url, callback)
	}

	loadAnimatedModel(url, callback) {
		if (url === "" || url === null || url === undefined) {
			console.warn("Model URI is empty")
			return
		}

		let ext;
		if (url.indexOf(".") !== -1) {
			const s = url.split(".");
			ext = s[s.length - 1];
		}

		if (url.indexOf("?ext=") !== -1) {
			ext = url.split("?ext=")[1]
		}

		if (this.useLocalLoad) {
			url = this.toLocalUrl(url)
		}


		// console.debug("Loading animated model: ", url, ext)
		this.loadingCount++;
		// console.log("Loading Count: ", this.loadingCount)
		switch (ext.toLowerCase()) {
			case "fbx":
				this.loaders.fbx.loadAnimatedModel(url, callback)
				// this._loadAnimatedFBX(url, callback)
				break
			case "gltf":
			case "glb":
				this.loaders.glb.loadAnimatedModel(url, callback)
				// this._loadAnimatedGLTF(url, callback)
				break
			case "png":
			case "jpeg":
			case "jpg":
				this.loaders.image.loadAnimatedModel(url, callback)
				// this._loadAnimatedImage(url, callback)
				break
			case "gif":
				this.loaders.gif.loadAnimatedModel(url, callback)
				break
			default:
				console.warn("Unknown file type: " + ext, url)
				throw new Error("Unsupported file type: " + ext)
		}
	}

	reset() {
		this.modelAnimationBindings = {};
		this.models = {} //TODO Diff check & only remove unneeded

		this.loadReadyPlayerMeBase()
		this.loadingCount = 0;
		this.loadedCount = 0;
		console.log("ModelManager reset", this)
	}

	/**
	 * Convert a url to a locally loadable url
	 *
	 * @param url
	 * @returns {*}
	 */
	toLocalUrl(url) {
		if (!this.useLocalLoad)
			return url

		for (let i = 0; i < this.remoteUrls.length; i++)
			if (url.indexOf(this.remoteUrls[i]) > -1)
				return url.replace(this.remoteUrls[i], this.localBase)

		return url
	}

	/**
	 * Configure local load settings
	 *
	 * @param params
	 */
	configureLocalLoad(params = {
		useLocalLoad: false,
		localBase: "http://localhost:8869",
		remoteUrls: []
	}) {
		this.useLocalLoad = params.useLocalLoad || this.useLocalLoad
		this.localBase = params.localBase || this.localBase
		this.remoteUrls = params.remoteUrls || this.remoteUrls
	}
}
